import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import Routes from 'config/routes';

const useSaveFrom = (key) => {
  if (!key) throw new Error('key cannot be empty');

  const location = useLocation();
  const [from] = useState(
    sessionStorage.getItem(key)
      ? JSON.parse(sessionStorage.getItem(key))
      : _extractFrom(location)
  );

  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(from));

    return () => {
      sessionStorage.removeItem(key);
    };
  }, [key, from]);

  return from;
};

const _extractFrom = (location) => {
  const { from } = location.state || { from: { pathname: Routes.HOME_PAGE } };
  return from;
};

export default useSaveFrom;
